import {
    Box, Divider, Flex, Image, ListItem, Radio, RadioGroup, Slider, Text, UnorderedList,
    Stack,
    Checkbox,
    Heading,
    Button
  } from '@chakra-ui/react'
  import React, { useEffect, useState, useRef } from 'react'
  import useLoader from "../../components/loader/loaderstates";
  import Loader from "../../components/loader/loader";
  import { addVisitFormDetail, getVisitFormDetail } from '../../middleware/services/home/childscreening';
  import { formatDate_DD_MM_YYYY, formatDate_Do_MMM_YYYY, getLoginID, handleAlphaNumericDotAndSpace, validationOfNumberWithOnly1Decimal } from '../../auth';
  import { useNavigate } from 'react-router-dom';
  import {
    addAllergies, uploadImageInProfile,
    getmedicalcondition, getVaccineList, addVaccination,
    deleteAllergies, deleteVacinations, editVaccinations, editAllergies
  } from '../../middleware/services/home/newvisitdetails'
  import { format, setDate } from "date-fns";
  import ModalRight from "../../components/modal-right";
  import DatePicker from "../../components/date-picker";
  import { DropdownInput, PrimaryButton, PrimaryInput, Toaster, SearchBar, PrimaryButtonIcon, PrimaryInputDropdown } from "../../components";
  import ReportViewCard from '../../components/report-card';
  import DynamicModal from "../../components/dynamic-modal";
  import moment from 'moment';
  import DropdownInputForVitals from '../../components/dropdown-input-forVitals';
  import { UpdateAppointmentStatus } from "../../middleware/services/visits/patient-overview";
  import {updateDoctorNotes } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import GrowthCalculator from './growthCalc';
  
  
  const InfantScreening = ({ patientid, appointmentid, patientData }) => {
    const { isLoading, showLoader, dismissLoader } = useLoader();
    const { showSuccessToast, showErrorToast } = Toaster();
    const [refresh, setRefresh] = useState(false);
    const [data, setData] = useState([]);
    const [AllergiesDataToBind, setAllergiesDataToBind] = useState([]);
    const [VaccinationDataToBind, setVaccinationDataToBind] = useState([]);
  
    const [growthHeight, setGrowthHeight] = useState(null);
    const [growthWeight, setGrowthWeight] = useState(null);
    const [ageMonths, setAgeMonths] = useState(null);

    const [zScoreWAZ, setZScoreWAZ] = useState("");
    const [zScoreHAZ, setZScoreHAZ] = useState("");
    const [zScoreWHZ, setZScoreWHZ] = useState("");
    const [stunting, setStunting] = useState("");
    const [wasting, setWasting] = useState("");
    const [underweight, setUnderweight] = useState("");
  
    const [weightChange, setWeightChange] = useState("");
  
    const [knownAllergies, setKnownAllergies] = useState("");
      const [knownAllergyDesc, setKnownAllergyDesc] = useState("");
      const [majorIllness, setMajorIllness] = useState("");
      const [majorIllnessDetails, setMajorIllnessDetails] = useState("");
      const [vaccinationsUpToDate, setVaccinationsUpToDate] = useState("");

  
  //   States for New Changes
  
  // Pregnancy & Birth History States
  const [gestationalDiabetes, setGestationalDiabetes] = useState("");
  const [pregnancyHTN, setPregnancyHTN] = useState("");
  const [hyperthyroidism, setHyperthryoidism] = useState("");
  const [pregnancyInfections, setPregnancyInfections] = useState("");
  const [pregnancyOthers, setPregnancyOthers] = useState("");
  const [pregnancyOthersDesc, setPregnancyOthersDesc] = useState("");
  const [othersInput, setOthersInput] = useState("");
  
  // Pregnancy Duration States
  const [pregnancyDuration, setPregnancyDuration] = useState("");
  
  // Mode of Delivery States
  const [modeOfDelivery, setModeOfDelivery] = useState("");
  
  // Birth Complications States
  const [birthAsphyxia, setBirthAsphyxia] = useState("");
  const [birthJaundice, setBirthJaundice] = useState("");
  const [congenitalAnomalies, setCongenitalAnomalies] = useState("");
  const [birthComplicationsOthers, setBirthComplicationsOthers] = useState("");
  const [birthComplicationsOthersDesc, setBirthComplicationsOthersDesc] = useState("");
  const [othersInputComplication, setOthersInputComplication] = useState("");

  
  // NICU Admission States
  const [nicuAdmission, setNicuAdmission] = useState("");
  
  // Height Weight States
  const [birthHeight, setBirthHeight] = useState("");
  const [birthWeight, setBirthWeight] = useState("");
  
  // Feeding History States
  const [feedingHistory, setFeedingHistory] = useState("");
  
  
    useEffect(() => {
      showLoader();
      var input = {
        "visitid": appointmentid,
        "patientid": patientid
      }
      var getInfantScreening = async () => {
        try {
          var result = await getVisitFormDetail(input);
          if (result?.output?.data != null) {
            setVaccinationDataToBind(result?.output?.data?.patientvaccination)
            setAllergiesDataToBind(result?.output?.data?.patientallergies)
          }
          if (result?.output?.data?.section_six) {
            setData(result?.output?.data?.section_six)
            // setGrowthHeight(result?.output?.data?.section_three.find(item => item.subquestion == "Height (in cm):")?.value);
            // setGrowthWeight(result?.output?.data?.section_three.find(item => item.subquestion ==  "Weight (in kg):")?.value);
            // setGrowthWeight(result?.output?.data?.section_three.find(item => item.subquestion ==  "Z-Scores (WHO Growth Standards):")?.value);
          }
        } catch (error) {
          console.error("Error in home:", error);
        }
        dismissLoader();
      };
      getInfantScreening();
    }, [refresh])
  
    const getPatientHealth = async (question) => {
      var input = {
        "visitid": appointmentid,
        "patientid": patientid
      }
      showLoader()
      try {
        var result = await getVisitFormDetail(input);
        if (result?.output?.data != null) {
          setVaccinationDataToBind(result?.output?.data?.patientvaccination)
          setAllergiesDataToBind(result?.output?.data?.patientallergies)
        }
        if (result?.output?.data?.patientvaccination == null && question.includes("vaccine")) {
          setVaccinationsUpToDate("No");
          saveToLocalStorage("vaccinationsUpToDate", "No");
        }
        if (result?.output?.data?.patientallergies == null && question.includes("Allergy")) {
          setKnownAllergies("No");
          saveToLocalStorage("knownAllergies", "No");
        }
      } catch (error) {
        console.error("Error in home:", error);
      }
      dismissLoader();
    };
  
    let inputForAdd = {
      "patientid": patientid,
      "visitid": appointmentid,
      "visitformdata": [
    
        // Pregnancy & Birth History Start
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.1,
          "subsectionname": "Pregnancy & Birth History",
          "question": "Pregnancy & Birth History",
          "subquestion": "Gestational Diabetes",
          "nestedquestion": null,
          "value": gestationalDiabetes ? gestationalDiabetes : null,
          // "value": gestationalDiabetes ? "Checked" : "Unchecked",
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.1,
          "subsectionname": "Pregnancy & Birth History",
          "question": "Pregnancy & Birth History",
          "subquestion": "HTN (Hypertension)",
          "nestedquestion": null,
          "value": pregnancyHTN ? pregnancyHTN : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.1,
          "subsectionname": "Pregnancy & Birth History",
          "question": "Pregnancy & Birth History",
          "subquestion": "Hyperthyroidism",
          "nestedquestion": null,
          "value": hyperthyroidism ? hyperthyroidism : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.1,
          "subsectionname": "Pregnancy & Birth History",
          "question": "Pregnancy & Birth History",
          "subquestion": "Infections",
          "nestedquestion": null,
          "value": pregnancyInfections ? pregnancyInfections : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.1,
          "subsectionname": "Pregnancy & Birth History",
          "question": "Pregnancy & Birth History",
          "subquestion": "Others",
          "nestedquestion": null,
          "value": pregnancyOthers ? pregnancyOthers : null,
          "description": othersInput ? othersInput : null
        },

        // {
        //   "sectionid": 6,
        //   "sectionname": "Infant Health Screening",
        //   "subsectionid": 6.1,
        //   "subsectionname": "Pregnancy & Birth History",
        //   "question": "Gestational Diabetes",
        //   "subquestion": null,
        //   "nestedquestion": null,
        //   "value": gestationalDiabetes ? gestationalDiabetes : null,
        //   // "value": gestationalDiabetes ? "Checked" : "Unchecked",
        //   "description": null
        // },
        // {
        //   "sectionid": 6,
        //   "sectionname": "Infant Health Screening",
        //   "subsectionid": 6.1,
        //   "subsectionname": "Pregnancy & Birth History",
        //   "question": "HTN (Hypertension)",
        //   "subquestion": null,
        //   "nestedquestion": null,
        //   "value": pregnancyHTN ? pregnancyHTN : null,
        //   "description": null
        // },
        // {
        //   "sectionid": 6,
        //   "sectionname": "Infant Health Screening",
        //   "subsectionid": 6.1,
        //   "subsectionname": "Pregnancy & Birth History",
        //   "question": "Hyperthyroidism",
        //   "subquestion": null,
        //   "nestedquestion": null,
        //   "value": hyperthyroidism ? hyperthyroidism : null,
        //   "description": null
        // },
        // {
        //   "sectionid": 6,
        //   "sectionname": "Infant Health Screening",
        //   "subsectionid": 6.1,
        //   "subsectionname": "Pregnancy & Birth History",
        //   "question": "Infections",
        //   "subquestion": null,
        //   "nestedquestion": null,
        //   "value": pregnancyInfections ? pregnancyInfections : null,
        //   "description": null
        // },
        // {
        //   "sectionid": 6,
        //   "sectionname": "Infant Health Screening",
        //   "subsectionid": 6.1,
        //   "subsectionname": "Pregnancy & Birth History",
        //   "question": "Others",
        //   "subquestion": null,
        //   "nestedquestion": null,
        //   "value": pregnancyOthers ? pregnancyOthers : null,
        //   "description": othersInput ? othersInput : null
        // },
  
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.2,
          "subsectionname": "Pregnancy Duration",
          "question": "How would you categorize the duration of the pregnancy?",
          "subquestion": null,
          "nestedquestion": null,
          "value": pregnancyDuration,
          "description": null
        },
  
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.3,
          "subsectionname": "Mode of Delivery",
          "question": "What was the mode of delivery?",
          "subquestion": null,
          "nestedquestion": null,
          "value": modeOfDelivery,
          "description": null
        },
  
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.4,
          "subsectionname": "Birth Complications",
          "question": "Birth Complications",
          "subquestion": "Asphyxia",
          "nestedquestion": null,
          "value": birthAsphyxia ? birthAsphyxia : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.4,
          "subsectionname": "Birth Complications",
          "question": "Birth Complications",
          "subquestion": "Jaundice",
          "nestedquestion": null,
          "value": birthJaundice ? birthJaundice : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.4,
          "subsectionname": "Birth Complications",
          "question": "Birth Complications",
          "subquestion": "Congenital Anomalies",
          "nestedquestion": null,
          "value": congenitalAnomalies ? congenitalAnomalies : null,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.4,
          "subsectionname": "Birth Complications",
          "question": "Birth Complications",
          "subquestion": "Others",
          "nestedquestion": null,
          "value": birthComplicationsOthers ? birthComplicationsOthers : null,
          "description": othersInputComplication
        },
  
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.5,
          "subsectionname": "History of NICU Admission",
          "question": "Is there a history of NICU admission?",
          "subquestion": null,
          "nestedquestion": null,
          "value": nicuAdmission,
          "description": null
        },

        //Growth and Development Start
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          // "subquestion": "Height (in cm)",
          "subquestion": "Height at Birth",
          "nestedquestion": null,
          "value": birthHeight ? birthHeight : null,
          "description": null,
          "unit": "cms"
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Weight at Birth",
          "nestedquestion": null,
          "value": birthWeight ? birthWeight : null,
          "description": null,
          "unit": "kg"
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Z-Scores (WHO Growth Standards)",
          "subquestion": "Weight-for-Age (WAZ)",
          "nestedquestion": "Weight-for-Age (WAZ)",
          "value": zScoreWAZ,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Height-for-Age (HAZ)",
          "nestedquestion": "Height-for-Age (HAZ)",
          "value": zScoreHAZ,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Weight-for-Height (WHZ)",
          "nestedquestion": "Weight-for-Height (WHZ)",
          "value": zScoreWHZ,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Stunting (HAZ < -2)",
          "nestedquestion": null,
          "value": stunting,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Wasting (WHZ < -2)",
          "nestedquestion": null,
          "value": wasting,
          "description": null
        },
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.6,
          "subsectionname": "Growth and Development",
          "question": "According to the WHO Growth Standards",
          "subquestion": "Underweight (WAZ < -2)",
          "nestedquestion": null,
          "value": underweight,
          "description": null
        },//Growth and Development End
  
        {
          "sectionid": 6,
          "sectionname": "Infant Health Screening",
          "subsectionid": 6.7,
          "subsectionname": "Feeding History",
          "question": "What type of feeding does the baby receive?",
          "subquestion": null,
          "nestedquestion": null,
          "value": feedingHistory,
          "description": null
        }
        // Pregnancy & Birth History End
      ]
    };
  //   let inputForAdd = {
  //     "patientid": patientid,
  //     "visitid": appointmentid,
  
  //     "visitformdata": [
  
  //       //Growth and Development Start
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.6,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Height (in cm)",
  //         "nestedquestion": null,
  //         "value": growthHeight ? growthHeight : null,
  //         "description": null,
  //         "unit": "cms"
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Weight (in kg)",
  //         "nestedquestion": null,
  //         "value": growthWeight ? growthWeight : null,
  //         "description": null,
  //         "unit": "kg"
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Z-Scores (WHO Growth Standards)",
  //         "nestedquestion": "Weight-for-Age (WAZ)",
  //         "value": zScoreWAZ,
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Z-Scores (WHO Growth Standards)",
  //         "nestedquestion": "Height-for-Age (HAZ)",
  //         "value": zScoreHAZ,
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Z-Scores (WHO Growth Standards)",
  //         "nestedquestion": "Weight-for-Height (WHZ)",
  //         "value": zScoreWHZ,
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Stunting (HAZ < -2)",
  //         "nestedquestion": null,
  //         "value": stunting,
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Wasting (WHZ < -2)",
  //         "nestedquestion": null,
  //         "value": wasting,
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.1,
  //         "subsectionname": "Growth and Development",
  //         "question": "According to the WHO Growth Standards",
  //         "subquestion": "Underweight (WAZ < -2)",
  //         "nestedquestion": null,
  //         "value": underweight,
  //         "description": null
  //       },//Growth and Development End
  
  //       //WHO Start
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "WHO Growth Questions",
  //         "question": "Has your child experienced any growth-related concerns (e.g., delayed growth, slow weight gain, or being smaller for age)?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": growthConcerns ? growthConcerns : 'No',
  //         "description": growthConcernsDesc
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "WHO Growth Questions",
  //         "question": "Is your child’s growth monitored regularly (e.g., through routine health check-ups)?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": growthMonitored ? growthMonitored : "Yes",
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "WHO Growth Questions",
  //         "question": "Has your child’s weight increased or decreased unexpectedly in the last 6 months?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": weightChange ? weightChange : 'Increased',
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "WHO Growth Questions",
  //         "question": "Does your child have difficulty in eating or have a reduced appetite?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": eatingDifficulty ? eatingDifficulty : 'No',
  //         "description": eatingDifficultyDesc
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "WHO Growth Questions",
  //         "question": "Has your child been hospitalized or received treatment for any malnutrition-related conditions?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": malnutritionTreatment ? malnutritionTreatment : 'No',
  //         "description": malnutritionTreatmentDesc
  //       },//WHO End
  
  //       //General Health  Start
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "General Health Information",
  //         "question": "Does your child have any known allergies?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": knownAllergies ? knownAllergies : 'No',
  //         "description": knownAllergyDesc
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "General Health Information",
  //         "question": "Has your child experienced any major illnesses?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": majorIllness ? majorIllness : 'No',
  //         "description": majorIllnessDetails
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.2,
  //         "subsectionname": "General Health Information",
  //         "question": "Is your child up to date with vaccinations? ",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": vaccinationsUpToDate,
  //         "description": null
  //       },
  //       //General Health  End
  
  //       //Symptom Screening Start --
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.3,
  //         "subsectionname": "Symptom Screening",
  //         "question": "Has your child experienced any of the following symptoms recently?",
  //         "subquestion": "Frequent Colds or Infections",
  //         "nestedquestion": null,
  //         "value": coldState ? coldState : 'No',
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.3,
  //         "subsectionname": "Symptom Screening",
  //         "question": "Has your child experienced any of the following symptoms recently?",
  //         "subquestion": "Fever",
  //         "nestedquestion": null,
  //         "value": feverState ? feverState : "No",
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.3,
  //         "subsectionname": "Symptom Screening",
  //         "question": "Has your child experienced any of the following symptoms recently?",
  //         "subquestion": "Shortness of Breath",
  //         "nestedquestion": null,
  //         "value": breathState ? breathState : 'No',
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.3,
  //         "subsectionname": "Symptom Screening",
  //         "question": "Has your child experienced any of the following symptoms recently?",
  //         "subquestion": "Vomiting or Diarrhea",
  //         "nestedquestion": null,
  //         "value": vomitState ? vomitState : "No",
  //         "description": null
  //       },
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.3,
  //         "subsectionname": "Symptom Screening",
  //         "question": "Has your child experienced any of the following symptoms recently?",
  //         "subquestion": "Fatigue or Lethargy",
  //         "nestedquestion": null,
  //         "value": fatigueState ? fatigueState : 'No',
  //         "description": null
  //       },     //Symptom Screening End
  
  //       //Nutrition Start 
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.4,
  //         "subsectionname": "Nutrition and Eating Habits",
  //         "question": "Does your child have a balanced diet?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": balancedDiet ? balancedDiet : 'Yes',
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.4,
  //         "subsectionname": "Nutrition and Eating Habits",
  //         "question": "How often does your child consume the following?",
  //         "subquestion": "Fruits",
  //         "nestedquestion": null,
  //         "value": fruitsFrequency ? fruitsFrequency : 'Sometimes',
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.4,
  //         "subsectionname": "Nutrition and Eating Habits",
  //         "question": "How often does your child consume the following?",
  //         "subquestion": "Vegetables",
  //         "nestedquestion": null,
  //         "value": vegetablesFrequency ? vegetablesFrequency : 'Sometimes',
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.4,
  //         "subsectionname": "Nutrition and Eating Habits",
  //         "question": "How often does your child consume the following?",
  //         "subquestion": "Meat or Proteins",
  //         "nestedquestion": null,
  //         "value": meatFrequency ? meatFrequency : 'Sometimes',
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.4,
  //         "subsectionname": "Nutrition and Eating Habits",
  //         "question": "How often does your child consume the following?",
  //         "subquestion": "Dairy Products",
  //         "nestedquestion": null,
  //         "value": dairyFrequency ? dairyFrequency : 'Sometimes',
  //         "description": null
  //       },// nutrituon End
  
  //       // Family Start 
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.5,
  //         "subsectionname": "Family Medical History",
  //         "question": "Is there any family history of the following conditions?",
  //         "subquestion": "Diabetes",
  //         "nestedquestion": null,
  //         "value": familyHistoryDiabetes ? familyHistoryDiabetes : 'No',
  
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.5,
  //         "subsectionname": "Family Medical History",
  //         "question": "Is there any family history of the following conditions?",
  //         "subquestion": "Hypertension",
  //         "nestedquestion": null,
  //         "value": familyHistoryHypertension ? familyHistoryHypertension : 'No',
  
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.5,
  //         "subsectionname": "Family Medical History",
  //         "question": "Is there any family history of the following conditions?",
  //         "subquestion": "Asthma",
  //         "nestedquestion": null,
  //         "value": familyHistoryAsthma ? familyHistoryAsthma : 'No',
  
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.5,
  //         "subsectionname": "Family Medical History",
  //         "question": "Is there any family history of the following conditions?",
  //         "subquestion": "Heart Disease",
  //         "nestedquestion": null,
  //         "value": familyHistoryHeartDisease ? familyHistoryHeartDisease : 'No',
  //         "description": null
  //       },// Family End
  
  //       // Scool Start 
  //       {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.6,
  //         "subsectionname": "School Performance",
  //         "question": "Does your child attend school regularly?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": schoolAttendance ? schoolAttendance : 'Yes',
  //         "description": null
  //       }, {
  //         "sectionid": 3,
  //         "sectionname": "Child Health Screening",
  //         "subsectionid": 3.6,
  //         "subsectionname": "School Performance",
  //         "question": "Are there any concerns regarding your child’s school performance?",
  //         "subquestion": null,
  //         "nestedquestion": null,
  //         "value": schoolPerformance ? schoolPerformance : 'No',
  //         "description": schoolPerformanceConcerns
  //       }
  
  //       // Scool End
  
  //     ]
  
  //   }
  
    let navigate = useNavigate();
    function createNew(type) {
  
      var addChildScreening = async () => {
        showLoader();
        try {
          inputForAdd.visitformdata = inputForAdd.visitformdata.map((item, index) => ({
            ...item,
            questionnumber: index + 1, // Adding question number starting from 1
          }));
          var result = await addVisitFormDetail(inputForAdd);
          if (result.output.message == "Successfully Inserted") {
            showSuccessToast("Infant Screening details have been saved successfully!");
            if(type === "end"){
              const doctorid = getLoginID();
                  const inputForEnd = {
                    input: {
                      doctorid: doctorid,
                      appointmentid: appointmentid,
                      type: "end",
                      time: new Date().toISOString(), // current timestamp
                    },
                  };
                  const inputToFollowUp = {
                    input: {
                      patientid: patientid,
                      doctorid: doctorid,
                      appointmentid: appointmentid,
                      appointmentenddate: new Date().toISOString(), // current timestamp
                      completed: "3",
                    },
                  };
                  try {
                    // showLoader();
          
                    // console.log("change status to end", inputForEnd);
                    await UpdateAppointmentStatus(inputForEnd.input);
                    const result = await updateDoctorNotes(inputToFollowUp.input);
                    if (result) {
                      window.history.back();
                    } else {
                      showErrorToast("Something went wrong!");
                    }
                  } catch (error) {
                    console.error("Error ending visit:", error);
                    showErrorToast("An error occurred while ending visit");
                  } 
            }
            else{
            setRefresh(!refresh)
            setTimeout(() => {
              // const newActiveComponent = "child-screening";
              // onSubmit(newActiveComponent);
  
              let doctorid = getLoginID();
              if (patientData?.type === "startvisit") {
                navigate(`/quickvisit?doctorId=${doctorid}&patientId=${patientid}&appointmentId=${appointmentid}`)
                // navigate(`/startvisit?doctorId=${doctorid}&patientId=${patientid}&appointmentId=${appointmentid}`)
              } else {
                navigate(`/visitdetails?patientId=${patientid}&appointmentId=${appointmentid}`)
              }
            }, 1000);
          }
        }
        } catch (error) {
          console.error("Error in home:", error);
        }
        dismissLoader();
      };
  
      addChildScreening();
    }
  

  //   Can use this as well
    const questionnaire = [
      {
          section: "Pregnancy & Birth History",
          questions: [
            {
              question: "Pregnancy & Birth History",
              subquestions: [
                { question: "Gestational Diabetes", answer: gestationalDiabetes, type: "checkbox" },
                { question: "HTN (Hypertension)", answer: pregnancyHTN, type: "checkbox" },
                { question: "Hyperthyroidism", answer: hyperthyroidism, type: "checkbox" },
                { question: "Infections", answer: pregnancyInfections, type: "checkbox" },
                { question: "Others", answer: pregnancyOthers, type: "checkbox", moreinfo: { question: "If yes, please specify", answer: othersInput } },
              ],
            },
          ],
      },
  
      {
          section: "Pregnancy Duration",
          questions: [
              {
                question: "How would you categorize the duration of the pregnancy?",
                answer: pregnancyDuration,
                options: ["Full Term", "Pre-Term", "Post Term"],
              },
          ]
      },
  
      {
          section: "Mode of Delivery",
          questions: [
              {
                question: "What was the mode of delivery?",
                answer: modeOfDelivery,
                options: ["NVD", "C Section", "Spontaneous", "Induced"],
              },
          ]
      },
  
      {
          section: "Birth Complications",
          questions: [
              {
                  question: "Birth Complications",
                  subquestions: [
                      { question: "Asphyxia", answer: birthAsphyxia, type: "checkbox" },
                      { question: "Jaundice", answer: birthJaundice, type: "checkbox" },
                      { question: "Congenital Anomalies", answer: congenitalAnomalies, type: "checkbox" },
                      { question: "Others", answer: birthComplicationsOthers, type: "checkbox", moreinfo: { question: "If yes, please specify", answer: othersInputComplication } },
                  ],
              },
          ]
      },
  
      {
          section: "History of NICU Admission",
          questions: [
              {
                question: "Is there a history of NICU admission?",
                answer: nicuAdmission,
                options: ["Yes", "No"],
              },
          ]
      },
  
      {
          section: "Growth and Development",
          // section: "Weight At Birth",
          questions: [
            {
              question: "According to the WHO Growth Standards",
              subquestions: [
                { question: "Height at Birth", unit: "cm", answer: birthHeight },
                { question: "Weight at Birth", unit: "kg", answer: birthWeight },
                {
                  question: "Z-Scores (WHO Growth Standards):",
                  subquestions: [
                    { question: "Weight-for-Age (WAZ)", answer: zScoreWAZ },
                    //  { question: "Weight-for-Age (WAZ)", answer: zScoreHAZ },
                    { question: "Height-for-Age (HAZ)", answer: zScoreHAZ },
                    { question: "Weight-for-Height (WHZ)", answer: zScoreWHZ },
                    { question: "Stunting (HAZ < -2)", answer: stunting, options: ["Normal", "Stunted"], },
                    { question: "Wasting (WHZ < -2)", answer: wasting, options: ["Normal", "Wasted"], },
                    { question: "Underweight (WAZ < -2)", answer: underweight, options: ["Normal", "Underweight"], },
                  ],
                },
  
              ],
            },
          ],
      },
  
      {
          section: "Feeding History",
          questions: [
              {
                question: "What type of feeding does the baby receive?",
                answer: feedingHistory,
                options: ["EXDBF", "Formula", "Mixed"],
              },
          ]
      },
  ];
  //   const questionnaire = [
  //     {
  //       section: "Growth and Development",
  //       questions: [
  //         {
  //           question: "According to the WHO Growth Standards",
  //           subquestions: [
  //             { question: "Height (in cm)", unit: "cm", answer: growthHeight },
  //             { question: "Weight (in kg)", unit: "kg", answer: growthWeight },
  //             {
  //               question: "Z-Scores (WHO Growth Standards):",
  //               subquestions: [
  //                 { question: "Weight-for-Age (WAZ)", answer: zScoreWAZ },
  //                 //  { question: "Weight-for-Age (WAZ)", answer: zScoreHAZ },
  //                 { question: "Height-for-Age (HAZ)", answer: zScoreHAZ },
  //                 { question: "Weight-for-Height (WHZ)", answer: zScoreWHZ },
  //                 { question: "Stunting (HAZ < -2)", answer: stunting, options: ["Normal", "Stunted"], },
  //                 { question: "Wasting (WHZ < -2)", answer: wasting, options: ["Normal", "Wasted"], },
  //                 { question: "Underweight (WAZ < -2)", answer: underweight, options: ["Normal", "Underweight"], },
  //               ],
  //             },
  
  //           ],
  //         },
  //         {
  //           question: "WHO Growth Questions",
  //           subquestions: [
  //             {
  //               question: "Has your child experienced any growth-related concerns (e.g., delayed growth, slow weight gain, or being smaller for age)?",
  //               answer: growthConcerns ? growthConcerns : 'No',
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: growthConcernsDesc },
  //             },
  
  //             {
  //               question: "Is your child’s growth monitored regularly (e.g., through routine health check-ups)?",
  //               answer: growthMonitored ? growthMonitored : 'Yes',
  //               options: ["Yes", "No"],
  //             },
  //             {
  //               question: "Has your child’s weight increased or decreased unexpectedly in the last 6 months?",
  //               answer: weightChange ? weightChange : 'Increased',
  //               options: ["Increased", "Decreased", "No Change"],
  //             },
  //             {
  //               question: "Does your child have difficulty in eating or have a reduced appetite?",
  //               answer: eatingDifficulty ? eatingDifficulty : 'No',
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: eatingDifficultyDesc },
  //             },
  //             {
  //               question: "Has your child been hospitalized or received treatment for any malnutrition-related conditions?",
  //               answer: malnutritionTreatment ? malnutritionTreatment : 'No',
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: malnutritionTreatmentDesc },
  //             },
  
  //           ],
  //         },
  //         {
  //           question: "General Health Information",
  //           subquestions: [
  //             {
  //               question: "Does your child have any known allergies? ",
  //               answer: knownAllergies ? knownAllergies : "No",
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: knownAllergyDesc },
  //             },
  //             {
  //               question: "Has your child experienced any major illnesses? ",
  //               answer: majorIllness ? majorIllness : 'No',
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: majorIllnessDetails },
  //             },
  //             {
  //               question: "Is your child up to date with vaccinations?",
  //               answer: vaccinationsUpToDate,
  //               options: ["Yes", "No"],
  //               moreinfo: { question: "If yes, please specify", answer: null },
  //             },
  //           ]
  //         },
  //         {
  //           question: "Has your child experienced any of the following symptoms recently?",
  //           subquestions: [
  //             { question: "Frequent Colds or Infections", answer: coldState ? coldState : 'No', options: ["Yes", "No"] },
  //             { question: "Fever", answer: feverState ? feverState : 'No', options: ["Yes", "No"] },
  //             { question: "Shortness of Breath", answer: breathState ? breathState : 'No', options: ["Yes", "No"] },
  //             { question: "Vomiting or Diarrhea", answer: vomitState ? vomitState : 'No', options: ["Yes", "No"] },
  //             { question: "Fatigue or Lethargy", answer: fatigueState ? fatigueState : 'No', options: ["Yes", "No"] },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       section: "Nutrition and Eating Habits",
  //       questions: [
  //         {
  //           question: "Does your child have a balanced diet?",
  //           answer: balancedDiet ? balancedDiet : 'Yes',
  //           options: ["Yes", "No"],
  //         },
  //         {
  //           question: "How often does your child consume the following?",
  //           subquestions: [
  //             { question: "Fruits", answer: fruitsFrequency ? fruitsFrequency : 'Sometimes', options: ["Daily", "Sometimes", "Rarely"] },
  //             { question: "Vegetables", answer: vegetablesFrequency ? vegetablesFrequency : 'Sometimes', options: ["Daily", "Sometimes", "Rarely"] },
  //             { question: "Meat or Protein", answer: meatFrequency ? meatFrequency : 'Sometimes', options: ["Daily", "Sometimes", "Rarely"] },
  //             { question: "Dairy Products", answer: dairyFrequency ? dairyFrequency : 'Sometimes', options: ["Daily", "Sometimes", "Rarely"] },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       section: "Family Medical History",
  //       questions: [
  //         {
  //           question: "Is there any family history of the following conditions?",
  //           subquestions: [
  //             { question: "Diabetes", answer: familyHistoryDiabetes ? familyHistoryDiabetes : 'No', options: ["Yes", "No"] },
  //             { question: "Hypertension", answer: familyHistoryHypertension ? familyHistoryHypertension : 'No', options: ["Yes", "No"] },
  //             { question: "Asthma", answer: familyHistoryAsthma ? familyHistoryAsthma : 'No', options: ["Yes", "No"] },
  //             { question: "Heart Disease", answer: familyHistoryHeartDisease ? familyHistoryHeartDisease : 'No', options: ["Yes", "No"] },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       section: "School Performance",
  //       questions: [
  //         {
  //           question: "Does your child attend school regularly?",
  //           answer: schoolAttendance ? schoolAttendance : 'Yes',
  //           options: ["Yes", "No"],
  //         },
  //         {
  //           question: "Are there any concerns regarding your child’s school performance?",
  //           answer: schoolPerformance ? schoolPerformance : 'No',
  //           options: ["Yes", "No"],
  //           moreinfo: { question: "If yes, please specify", answer: schoolPerformanceConcerns },
  //         },
  //       ],
  //     },
  //   ];
    function handleHeightWeightBasic(unit, e) {
      let value = validationOfNumberWithOnly1Decimal(e.target.value, 6)
      if (unit.includes("cm")) {
        setBirthHeight(value);
        saveToLocalStorage("birthHeight", value);
      } else if (unit.includes("kg")) {
        setBirthWeight(value);
        saveToLocalStorage("birthWeight", value);
      }
    }
  
    function handleHeightWeightZScores(unit, e) {
      let value = validationOfNumberWithOnly1Decimal(e.target.value, 6)
      // console.log(unit, "unit");
      if (unit.includes("WAZ")) {
        setZScoreWAZ(value);
        saveToLocalStorage("zScoreWAZ", value);
      } else if (unit.includes("HAZ")) {
        setZScoreHAZ(value);
        saveToLocalStorage("zScoreHAZ", value);
      } else if (unit.includes("WHZ")) {
        setZScoreWHZ(value);
        saveToLocalStorage("zScoreWHZ", value);
      }
    }
  
    function handleMoreInfo(unit, e) {
      // console.log('unit: ', unit)
      const value = e.target.value;

      if (unit.includes("Others")) {
        // setMajorIllnessDetails(value);
        // saveToLocalStorage("majorIllnessDesc", value);
        setOthersInput(value);
      saveToLocalStorage("othersInput", othersInput)
      }


    }
    function handleMoreInfoComplications(unit, e) {
      // console.log('unit: ', unit)
      const value = e.target.value;

      if (unit.includes("Others")) {
        // setMajorIllnessDetails(value);
        // saveToLocalStorage("majorIllnessDesc", value);
        setOthersInputComplication(value);
      saveToLocalStorage("othersInputComplication", othersInputComplication)
      }


    }
  
    function handleChangeRadio(value, question) {
      // console.log(value, "value");
      // console.log(question, "question");
  
      if (question.includes("Stunting")) {
        setStunting(value);
        saveToLocalStorage("stunting", value);
      } else if (question.includes("Wasting")) {
        setWasting(value);
        saveToLocalStorage("wasting", value);
      } else if (question.includes("Underweight")) {
        setUnderweight(value);
        saveToLocalStorage("underweight", value);
      } else if(question.includes("How would you categorize the duration of the pregnancy?")) {
        setPregnancyDuration(value)
        saveToLocalStorage("pregnancyduration", value)
      } else if(question.includes("What was the mode of delivery?")) {
        setModeOfDelivery(value)
        saveToLocalStorage("modeofdelivery", value)
      } else if(question.includes("Is there a history of NICU admission?")) {
        setNicuAdmission(value)
        saveToLocalStorage("nicuadmission", value)
      } else if(question.includes("What type of feeding does the baby receive?")) {
        setFeedingHistory(value)
        saveToLocalStorage("feedinghistory", value)
      } 
    }
    // function handleChangeRadio(value, question) {
    //   // console.log(value, "value");
    //   // console.log(question, "question");
  
    //   if (question.includes("Stunting")) {
    //     setStunting(value);
    //     saveToLocalStorage("stunting", value);
    //   } else if (question.includes("Wasting")) {
    //     setWasting(value);
    //     saveToLocalStorage("wasting", value);
    //   } else if (question.includes("Underweight")) {
    //     setUnderweight(value);
    //     saveToLocalStorage("underweight", value);
    //   } else if (question.includes("growth-related concerns")) {
    //     setGrowthConcerns(value);
    //     saveToLocalStorage("growthConcerns", value);
    //   } else if (question.includes("Is your child’s growth monitored regularly")) {
    //     setGrowthMonitored(value);
    //     saveToLocalStorage("growthMonitored", value);
    //   } else if (question.includes("Has your child’s weight increased or decreased")) {
    //     setWeightChange(value);
    //     saveToLocalStorage("weightChange", value);
    //   } else if (question.includes("Does your child have difficulty in eating")) {
    //     setEatingDifficulty(value);
    //     saveToLocalStorage("eatingDifficulty", value);
    //   } else if (question.includes("malnutrition-related conditions")) {
    //     setMalnutritionTreatment(value);
    //     saveToLocalStorage("malnutritionTreatment", value);
    //   }
  
    //   else if (question.includes("Does your child have any known allergies")) {
    //     setKnownAllergies(value);
    //     saveToLocalStorage("knownAllergies", value);
    //     if (value === "Yes") {
    //     //   openAllergiesModal();
    //     }
  
    //   }
    //   else if (question.includes("Has your child experienced any major illnesses")) {
    //     setMajorIllness(value);
    //     saveToLocalStorage("majorIllness", value);
    //   }
  
  
    //   else if (question.includes("Is your child up to date with vaccinations")) {
    //     setVaccinationsUpToDate(value);
    //     saveToLocalStorage("vaccinationsUpToDate", value);
    //     if (value === "Yes") {
    //     //   openVaccinationsModal();
    //     }
  
    //   }
  
    //   else if (question.includes("Frequent Colds or Infections")) {
    //     setColdState(value);
    //     saveToLocalStorage("coldState", value);
    //   } else if (question.includes("Fever")) {
    //     setFeverState(value);
    //     saveToLocalStorage("feverState", value);
    //   } else if (question.includes("Shortness of Breath")) {
    //     setBreathState(value);
    //     saveToLocalStorage("breathState", value);
    //   } else if (question.includes("Vomiting or Diarrhea")) {
    //     setVomitState(value);
    //     saveToLocalStorage("vomitState", value);
    //   } else if (question.includes("Fatigue or Lethargy")) {
    //     setFatigueState(value);
    //     saveToLocalStorage("fatigueState", value);
    //   } else if (question.includes("Does your child have a balanced diet?")) {
    //     setBalancedDiet(value);
    //     saveToLocalStorage("balancedDiet", value);
    //   } else if (question.includes("Fruits")) {
    //     setFruitsFrequency(value);
    //     saveToLocalStorage("fruitsFrequency", value);
    //   } else if (question.includes("Vegetables")) {
    //     setVegetablesFrequency(value);
    //     saveToLocalStorage("vegetablesFrequency", value);
    //   } else if (question.includes("Meat or Protein")) {
    //     setMeatFrequency(value);
    //     saveToLocalStorage("meatFrequency", value);
    //   } else if (question.includes("Dairy Products")) {
    //     setDairyFrequency(value);
    //     saveToLocalStorage("dairyFrequency", value);
    //   } else if (question.includes("Diabetes")) {
    //     setFamilyHistoryDiabetes(value);
    //     saveToLocalStorage("familyHistoryDiabetes", value);
    //   } else if (question.includes("Hypertension")) {
    //     setFamilyHistoryHypertension(value);
    //     saveToLocalStorage("familyHistoryHypertension", value);
    //   } else if (question.includes("Asthma")) {
    //     setFamilyHistoryAsthma(value);
    //     saveToLocalStorage("familyHistoryAsthma", value);
    //   } else if (question.includes("Heart Disease")) {
    //     setFamilyHistoryHeartDisease(value);
    //     saveToLocalStorage("familyHistoryHeartDisease", value);
    //   } else if (question.includes("Does your child attend school regularly")) {
    //     setSchoolAttendance(value);
    //     saveToLocalStorage("schoolAttendance", value);
    //   } else if (question.includes("Are there any concerns regarding your child’s school performance")) {
    //     setSchoolPerformance(value);
    //     saveToLocalStorage("schoolPerformance", value);
    //   }
    // }
  
    // Helper function to save data to localStorage
    function saveToLocalStorage(key, value) {
      const storedData = JSON.parse(localStorage.getItem("formData")) || {};
      storedData[key] = value;
      localStorage.setItem("formData", JSON.stringify(storedData));
    }
  
    useEffect(() => {
      const storedData = JSON.parse(localStorage.getItem("formData"));
      // console.log(storedData, "storedData")
  
      if (storedData) {
  
        setBirthHeight(storedData.birthHeight || "");
        setBirthWeight(storedData.birthWeight || "");
        setZScoreWAZ(storedData.zScoreWAZ || "");
        setZScoreHAZ(storedData.zScoreHAZ || "");
        setZScoreWHZ(storedData.zScoreWHZ || "");
        setStunting(storedData.stunting || "");
        setWasting(storedData.wasting || "");
        setUnderweight(storedData.underweight || "");
        setWeightChange(storedData.weightChange || "");
        
        setPregnancyDuration(storedData.pregnancyduration || "");
        setModeOfDelivery(storedData.modeofdelivery || "");
        setNicuAdmission(storedData.nicuadmission || "");
        setFeedingHistory(storedData.feedinghistory || "");
        
        setSelectedCheckboxes(storedData.selectedcheckbox || "")
        setOthersInput(storedData.othersInput || "")

        setSelectedComplicationsCheckboxes(storedData.selectedcomplicationcheckbox || "")
        setOthersInputComplication(storedData.othersInputComplication || "")
      }
    }, []);
    
    // Mouse dragging logic
    const scrollRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
  
    const handleMouseDown = (event) => {
      isDragging.current = true;
      startX.current = event.pageX - scrollRef.current.offsetLeft;
      scrollLeft.current = scrollRef.current.scrollLeft;
    };
  
    const handleMouseLeave = () => {
      isDragging.current = false;
    };
  
    const handleMouseUp = () => {
      isDragging.current = false;
    };
  
    const handleMouseMove = (event) => {
      if (!isDragging.current) return;
      event.preventDefault();
      const x = event.pageX - scrollRef.current.offsetLeft;
      const walk = (x - startX.current) * 1.5; // The multiplier increases the drag speed
      scrollRef.current.scrollLeft = scrollLeft.current - walk;
    };

  
    const [selectedCheckboxes, setSelectedCheckboxes] = useState(
      questionnaire[0].questions[0].subquestions.map((sub) => sub.answer)
    );
  
    // Handle checkbox change
    const handleCheckboxChange = (question, index) => {
      if(index == 0) {
            setGestationalDiabetes(question)
          } else if(index == 1) {
            setPregnancyHTN(question)
          } else if(index == 2) {
            setHyperthryoidism(question)
          } else if(index == 3) {
            setPregnancyInfections(question)
          } else if(index == 4) {
            setPregnancyOthers(question)
          } 
      setSelectedCheckboxes((prev) => {
        const updatedCheckboxes = [...prev];
        updatedCheckboxes[index] = !updatedCheckboxes[index]; // Toggle the checkbox
        saveToLocalStorage("selectedcheckbox", updatedCheckboxes)
        return updatedCheckboxes;
      });
    };
  
    // Handle "Others" input change
    const handleOthersInputChange = (e) => {
      setOthersInput(e.target.value);
      saveToLocalStorage("othersInput", othersInput)
    };

    const [selectedComplicationsCheckboxes, setSelectedComplicationsCheckboxes] = useState(
      questionnaire[3].questions[0].subquestions.map((sub) => sub.answer)
    );
  
    // Handle checkbox change
    const handleComplicationCheckboxChange = (question, index) => {
      if(index == 0) {
        setBirthAsphyxia(question)
      } else if(index == 1) {
        setBirthJaundice(question)
      } else if(index == 2) {
        setCongenitalAnomalies(question)
      } else if(index == 3) {
        setBirthComplicationsOthers(question)
      }

      setSelectedComplicationsCheckboxes((prev) => {
        const updatedCheckboxes = [...prev];
        updatedCheckboxes[index] = !updatedCheckboxes[index]; // Toggle the checkbox
        saveToLocalStorage("selectedcomplicationcheckbox", updatedCheckboxes)
        return updatedCheckboxes;
      });
    };
  
    // Handle "Others" input change
    const handleOthersInputChangeComplication = (e) => {
      setOthersInputComplication(e.target.value);
      saveToLocalStorage("othersInputComplication", othersInputComplication)
    };

    useEffect(() => {
        // setDob(patientData?.dob)
        calculateAgeInMonths(patientData?.dob)
      }, [])
    
      function calculateAgeInMonths(dob) {
        const dobDate = new Date(dob);
        const today = new Date();
    
        const years = today.getFullYear() - dobDate.getFullYear();
        const months = today.getMonth() - dobDate.getMonth();
        
        let totalMonths = years * 12 + months;
    
        // Adjust if the day of birth is greater than today's date
        if (today.getDate() < dobDate.getDate()) {
            totalMonths -= 1;
        }
    
        setAgeMonths(totalMonths)
        // console.log('user age: ', totalMonths)
    
        return `${totalMonths} months`;
    }
      
    // const [birthCheck, setBirthCheck] = useState(null);
    //     const [selectedBirthIndex, setSelectedBirthIndex] = useState(null);
      
    
    // const handleCheckboxChange = (e, question, index) => {
    //   console.log("e", e)
    //   console.log("question", question)
    //   console.log("index", index)
    //   if(index == 0) {
    //     setBirthCheck(question)
    //   } else if(index == 1) {
    //     setBirthCheck(question)
    //   } else if(index == 2) {
    //     setBirthCheck(question)
    //   } else if(index == 3) {
    //     setBirthCheck(question)
    //   } else if(index == 4) {
    //     setBirthCheck(question)
    //   } 
    //   // if(index == 0) {
    //   //   setBirthCheck(question)
    //   // } else if(index == 1) {
    //   //   setBirthCheck("hypertension")
    //   // } else if(index == 2) {
    //   //   setBirthCheck('hyperthyroidism')
    //   // } else if(index == 3) {
    //   //   setBirthCheck("infections")
    //   // } else if(index == 4) {
    //   //   setBirthCheck("others")
    //   // } 
    //   // else if(index == 5) {
    //   //   setCategory("conditions")
    //   // }
    //   setSelectedBirthIndex((prevIndex) => (prevIndex === index ? null : index));
    // };
    return (
      <>
        <Flex gap='1rem' flexDir='column'>
          {isLoading && <Loader />}
          {/* Pregnancy & Birth History Start */}
{questionnaire?.[0] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[0].section}</Text>
    <Box w="100%">
      {/* <Text fontSize="0.875rem" fontWeight="500" color="#7c7c7c" mb="0.5rem">{questionnaire[0].questions[0].question}</Text> */}
      <Flex flexDir="column" gap="0.75rem">
        {questionnaire[0].questions[0].subquestions.map((sub, idx) => (
          // <Box key={idx} onClick={() => handleCheckboxChange(sub.question, idx)}>
          <Box key={idx}>
            {/* <Flex justifyContent="space-between" alignItems="center" gap="0.75rem"> */}
            <Flex alignItems="center" gap="0.75rem">
              <Checkbox
                colorScheme="green"
                // isChecked={sub.answer === "Checked"}
                // isChecked={selectedBirthIndex === idx}
                isChecked={selectedCheckboxes[idx]}
                // onChange={(e) => handleCheckboxChange(e, sub.question, idx)}
                onChange={() => handleCheckboxChange(sub.question, idx)}
              />
              <Text fontSize="0.875rem" onClick={() => handleCheckboxChange(sub.question, idx)}>{sub.question}</Text>
            </Flex>
            {/* {sub.moreinfo && sub.answer === "Checked" && (
              <Box mt="1rem">
                <PrimaryInput
                  variant="fullRound"
                  inputPlace={sub.moreinfo.question}
                  inputValue={sub.moreinfo.answer}
                  onChange={(e) => handleMoreInfo(sub.question, e)}
                />
              </Box>
            )} */}
            {/* <Divider mt="0.75rem" /> */}

            {sub.moreinfo && selectedCheckboxes[idx] && (
                    <Box mt="1rem">
                      <PrimaryInput
                        variant="fullRound"
                        inputPlace={sub.moreinfo.question}
                        inputValue={othersInput}
                        // onChange={handleOthersInputChange}
                  onChange={(e) => handleMoreInfo(sub.question, e)}

                      />
                    </Box>
                  )}
          </Box>
        ))}
      </Flex>
    </Box>
  </>
)}
{/* Pregnancy & Birth History End */}

<Divider w="100%" />

{/* Pregnancy Duration Start */}
{questionnaire?.[1] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[1].section}</Text>
    <Box w="100%">
      <Flex gap="1rem" justifyContent="space-between" alignItems="center">
        <Text fontSize="0.875rem">{questionnaire[1].questions[0].question}</Text>
        <RadioGroup
          colorScheme="green"
          value={questionnaire[1].questions[0].answer}
          onChange={(value) => handleChangeRadio(value, questionnaire[1].questions[0].question)}
          display="flex"
          gap="1rem"
        >
          {questionnaire[1].questions[0].options.map((option, optionIdx) => (
            <Radio value={option} key={optionIdx}>
              <Text fontSize="0.875rem">{option}</Text>
            </Radio>
          ))}
        </RadioGroup>
      </Flex>
    </Box>
  </>
)}
{/* Pregnancy Duration End */}



<Divider w="100%" />

{/* Mode of Delivery Start */}
{questionnaire?.[2] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[2].section}</Text>
    <Box w="100%">
      <Flex gap="1rem" justifyContent="space-between" alignItems="center">
        <Text fontSize="0.875rem">{questionnaire[2].questions[0].question}</Text>
        <RadioGroup
          colorScheme="green"
          value={questionnaire[2].questions[0].answer}
          onChange={(value) => handleChangeRadio(value, questionnaire[2].questions[0].question)}
          display="flex"
          gap="1rem"
        >
          {questionnaire[2].questions[0].options.map((option, optionIdx) => (
            <Radio value={option} key={optionIdx}>
              <Text fontSize="0.875rem">{option}</Text>
            </Radio>
          ))}
        </RadioGroup>
      </Flex>
    </Box>
  </>
)}
{/* Mode of Delivery End */}

<Divider w="100%" />

{/* Birth Complications Start */}
{questionnaire?.[3] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[3].section}</Text>
    <Box w="100%">
      {/* <Text fontSize="0.875rem" fontWeight="500" color="#7c7c7c" mb="0.5rem">{questionnaire[0].questions[0].question}</Text> */}
      <Flex flexDir="column" gap="0.75rem">
        {questionnaire[3].questions[0].subquestions.map((sub, idx) => (
          // <Box key={idx} onClick={() => handleComplicationCheckboxChange(sub.question, idx)}>
          <Box key={idx}>
            <Flex alignItems="center" gap="0.75rem">
              <Checkbox
                colorScheme="green"
                isChecked={selectedComplicationsCheckboxes[idx]}
                onChange={() => handleComplicationCheckboxChange(sub.question, idx)}
              />
              <Text fontSize="0.875rem" onClick={() => handleComplicationCheckboxChange(sub.question, idx)}>{sub.question}</Text>
            </Flex>
            {sub.moreinfo && selectedComplicationsCheckboxes[idx] && (
                    <Box mt="1rem">
                      <PrimaryInput
                        variant="fullRound"
                        inputPlace={sub.moreinfo.question}
                        inputValue={othersInputComplication}
                        // onChange={handleOthersInputChangeComplication}
                  onChange={(e) => handleMoreInfoComplications(sub.question, e)}

                      />
                    </Box>
                  )}
          </Box>
        ))}
      </Flex>
    </Box>
  </>
)}
{/* Birth Complications End */}


<Divider w="100%" />

{/* History of NICU Admission Start */}
{questionnaire?.[4] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[4].section}</Text>
    <Box w="100%">
      <Flex gap="1rem" justifyContent="space-between" alignItems="center">
        <Text fontSize="0.875rem">{questionnaire[4].questions[0].question}</Text>
        <RadioGroup
          colorScheme="green"
          value={questionnaire[4].questions[0].answer}
          onChange={(value) => handleChangeRadio(value, questionnaire[4].questions[0].question)}
          display="flex"
          gap="1rem"
        >
          {questionnaire[4].questions[0].options.map((option, optionIdx) => (
            <Radio value={option} key={optionIdx}>
              <Text fontSize="0.875rem">{option}</Text>
            </Radio>
          ))}
        </RadioGroup>
      </Flex>
    </Box>
  </>
)}
{/* History of NICU Admission End */}

<Divider w="100%" />

{/* Existing */}
{/* Growth and Development Start */}
{/* {questionnaire?.[5] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[5].section}</Text>
    <Box w="100%">
      <Flex flexDir="column" gap="0.75rem">
        {questionnaire[5].questions[0].subquestions.map((sub, idx) => (
          <Box key={idx}>
            {sub.subquestions ? (
              <Box>
                <Text fontSize="0.875rem" fontWeight="600">{sub.question}</Text>
                <UnorderedList styleType="disc" pl={{ base: "1rem", md: "1.5rem" }} spacing="0.75rem">
                  {sub.subquestions.map((nestedSub, nestedIdx) => (
                    <ListItem key={nestedIdx} m="0" mt={{ base: nestedIdx === 0 ? "0.5rem" : "0", md: "0" }}>
                      {nestedSub.options ? (
                        <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                          <Text fontSize="0.875rem">{nestedSub.question}:</Text>
                          <RadioGroup colorScheme="green" value={nestedSub.answer} onChange={(value) => handleChangeRadio(value, nestedSub.question)} display="flex" gap="1rem">
                            {nestedSub.options.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                        </Flex>
                      ) : (
                        <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                          <Text fontSize="0.875rem">{nestedSub.question}:</Text>
                          <PrimaryInput
                            inputPlace="Enter value"
                            variant="fullRound"
                            inputStyleCss={{ width: "130px" }}
                            inputValue={nestedSub.answer}
                            onChange={(e) => handleHeightWeightZScores(nestedSub.question, e)}
                          />
                        </Flex>
                      )}
                    </ListItem>
                  ))}
                </UnorderedList>
              </Box>
            ) : (
              <Flex justifyContent="space-between" alignItems="center" gap="0.75rem">
                <Text fontSize="0.875rem">{sub.question}:</Text>
                <PrimaryInput
                  inputPlace={`Enter value (${sub.unit || ""})`}
                  variant="fullRound"
                  inputStyleCss={{ width: "150px" }}
                  inputValue={sub.answer}
                  onChange={(e) => handleHeightWeightBasic(sub.unit, e)}
                />
              </Flex>
            )}
          </Box>
        ))}
      </Flex>
    </Box>
  </>
)} */}
{/* Growth and Development End */}

{/* New */}
{/* Growth and Development Start */}
{questionnaire?.[5] && (
          <>

            <Text fontSize='1rem' fontWeight='600' mb='0.5rem'> {questionnaire[0].section}</Text>

            <Box w='100%'>
              <>
            <GrowthCalculator
        growthHeight={birthHeight}
        growthWeight={birthWeight}
        ageMonths={ageMonths}
        onHeightChange={(e) => handleHeightWeightBasic("cm", e)}
        onWeightChange={(e) => handleHeightWeightBasic("kg", e)}
        // onAgeChange={handleAgeChange}
        // onAgeChange={ageMonths}
        setZScoreWAZ={setZScoreWAZ}
        setZScoreHAZ={setZScoreHAZ}
        setZScoreWHZ={setZScoreWHZ}
        setStunting={setStunting}
        setWasting={setWasting}
        setUnderweight={setUnderweight}
      />
              
              </>

            </Box>
            {/* Growth and Development end */}
          </>
        )}
{/* Growth and Development End */}

<Divider w="100%" />

{/* Feeding History Start */}
{questionnaire?.[6] && (
  <>
    <Text fontSize="1rem" fontWeight="600" mb="0.5rem">{questionnaire[6].section}</Text>
    <Box w="100%">
      {/* <Flex gap="1rem" mt="0.875rem" justifyContent="space-between" alignItems="center"> */}
      <Flex gap="1rem" justifyContent="space-between" alignItems="center">
        <Text fontSize="0.875rem">{questionnaire[6].questions[0].question}</Text>
        <RadioGroup
          colorScheme="green"
          value={questionnaire[6].questions[0].answer}
          onChange={(value) => handleChangeRadio(value, questionnaire[6].questions[0].question)}
          display="flex"
          gap="1rem"
        >
          {questionnaire[6].questions[0].options.map((option, optionIdx) => (
            <Radio value={option} key={optionIdx}>
              <Text fontSize="0.875rem">{option}</Text>
            </Radio>
          ))}
        </RadioGroup>
      </Flex>
    </Box>
  </>
)}
{/* Feeding History End */}
          {/* <Box width="30%">
  
                          <PrimaryButton
                          buttonText="Add Child Screening"
                          // isDisabled={reactionsContinueBtnDisabled2}
                          onClick={() => createNew()}
                        />
                          </Box> */}
        </Flex>
        <Box
          pos="fixed"
          w={{ base: "100%", md: "calc(100% - 6rem)" }}
          left={{ base: "1px", md: "6rem" }}
          bottom={{ base: "65px", md: "0px" }}
          p="1rem"
          bg="white"
          boxShadow="rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px"
        >
          <Flex justify="flex-end" gap="1rem">
          <PrimaryButton
              buttonText="Save and close the visit"
              onClick={() => createNew("end")}
              btnStyle={{ w: { base: "100%", md: "20%" } }}
            />
            <PrimaryButton
              buttonText="Proceed"
              onClick={() => createNew()}
              btnStyle={{ w: { base: "100%", md: "20%" } }}
            />
           
          </Flex>
        </Box>

      </>
    )
  }
  
  export default InfantScreening;